// #region IMPORTS
// --------------------- IMPORTS ---------

import { createFileRoute, useLocation } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import useDrawerStore from '@/stores/useDrawerStore';
import Groups from '@/pages/groups';

// #endregion

// --------------------------------------------------------------------------------
// Component Implementation
// --------------------------------------------------------------------------------

// #region REACT.FC
/**
 * The Route component is a file route for the root '/' route.
 * Opens the groups drawer and displays Groups component or welcome message.
 * 
 * Feature Flow:
 * - Detects when user is on root route '/'
 * - Automatically opens the groups drawer if not already open
 * - Displays Groups component or welcome message in main content area
 * - Uses drawer store to manage drawer state
 */
function RootRouteComponent() {
  const { pathname } = useLocation();
  
  // Get drawer state and actions from Zustand store
  const activeDrawer = useDrawerStore((state) => state.activeDrawer);
  const openDrawer = useDrawerStore((state) => state.openDrawer);
  const hasBeenOpened = useRef(false);
// #endregion

  useEffect(() => {
    // Open groups drawer when on root route and drawer is not already open
    if (pathname === '/' && activeDrawer !== 'groups') {
      if(!hasBeenOpened.current) {openDrawer('groups');}
      hasBeenOpened.current = true;
    }
  }, [pathname, activeDrawer, openDrawer]);

  // Check if groups drawer is open
  const isAnyDrawerOpen = activeDrawer !== null;

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="text-center space-y-4 max-w-md px-4">
        <h1 className="text-2xl font-semibold text-foreground">Welcome</h1>
        <p className="text-muted-foreground">
          {isAnyDrawerOpen 
            ? 'Select an option from the sidebar on the left to get started.'
            : 'Open the sidebar from the left to navigate to your groups and get started.'}
        </p>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/_authenticated-layout/')({
  component: RootRouteComponent,
});
